import React from 'react'
import * as S from './Schedule.styles'
import { useIntl } from 'gatsby-plugin-intl'
import TabNavigator from 'components/TabNavigator'

const Schedule = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <S.Wrapper id="program">
      <S.Content>
        <S.TitleWrapper locale={locale}>
          <S.Title>{formatMessage({ id: 'schedule.title' })}</S.Title>
        </S.TitleWrapper>
        <TabNavigator />
      </S.Content>
    </S.Wrapper>
  )
}

export default Schedule
